import React from "react"
import { Link } from "gatsby"

import Layout from "../components/en/Layout"

const IndexPage = () => (
  <Layout>
    <h1>
      Welcome <span>&#128062;</span>
    </h1>
    <h2>What we want to do</h2>
    <p>Our goal is to help pet owners, lovers and guardians. If:</p>
    <p>
      <ul>
        <li>You found a lost or abandoned cat or dog;</li>
        <li>You lost your pet and need help to find it;</li>
        <li>You want to rescue an animal to care and adoption;</li>
        <li>You want to adopt a pet;</li>
        <li>You are a pet guardian and need help to manage your work;</li>
      </ul>
    </p>
    <p>
      <strong>achem-me</strong> is a service with application that will help
      with everything. And it's free.
    </p>
    <p>
      The idea is to use a smartphone to register animals seen at the streets,
      saving their localization and characteristics.
    </p>
    <p>
      As you take a photo, it automatically registers if it's a dog or a cat and
      in some cases even the breed. Next, you can fill in the other
      characteristics and it will be stored in a database with public access.
      The database can then be queried by place and physical characteristics.
    </p>
    <h3>Other services</h3>
    <p>
      You can also include lost animals and animals put to adoption. And more:
    </p>
    <p>
      <ul>
        <li>Register events and announcements to your area;</li>
        <li>Register yourseft as a guardian and animal donnor for adoption;</li>
      </ul>
    </p>
  </Layout>
)

export default IndexPage
